const aboutInfo = [
  "Hello, my name is Jarrod Skahill, and I am a junior full-stack developer. I started coding when I first built my personal computer and started creating two-dimensional games in unity with C#. A few months after that I took an interest in web-development and ended up taking an online course where I studied to become a full-stack developer",
];

export default aboutInfo;
